import * as actionTypes from "../actionTypes";
import {updateObject} from "../../shared/utils/updateObject";
import * as storageConstants from "../../shared/utils/constants/storage";
import {initialRichiesteAssistenzaSuggestionState, initialTableDataState} from "./helper";

const initialState = {
    aperte: initialTableDataState,
    archiviate: initialTableDataState,
    selectedTab: !sessionStorage.getItem(storageConstants.ASSISTENZA_TAB) ? 0 : parseInt(sessionStorage.getItem(storageConstants.ASSISTENZA_TAB)),
    richiesteAssistenzaSuggestion: initialRichiesteAssistenzaSuggestionState
};

const setSelectedTab = (state, action) => {
    return updateObject(state, {selectedTab: action.selectedTab});
}

const setLoadingAssistenza = (state, action) => {
    let tmpObj = { ...state[`${action.tab}`], loading: action.value };
    if (action.value) {
        tmpObj = { ...tmpObj, count: 0 };
    }
    return updateObject(state, { [`${action.tab}`]: tmpObj });
};

const fetchAssistenzaDataSuccess = (state, action) => {
    const tmpObject = {
        ...state[`${action.tab}`], data: action.data,
        count: action.count,
        rowsPerPage: action.rowsPerPage,
        page: action.page

    }
    return updateObject(state, {[`${action.tab}`]: tmpObject})
}

const setSortingRichiesta = (state, action) => {
    const tmpSort = {...state[`${action.tab}`], sorting: action.value}
    return updateObject(state, {[`${action.tab}`]: tmpSort})
}

const setRichiesteAssistenzaSuggestionLoading = (state, action) => {
    return updateObject(state, {richiesteAssistenzaSuggestion: {...state.richiesteAssistenzaSuggestion, loading: action.value}})
}

const setRichiesteAssistenzaFilterSuggestionData = (state, action) => {
    return updateObject(state, {richiesteAssistenzaSuggestion: {...state.richiesteAssistenzaSuggestion, menuItems: action.suggestionList}});
}

const richiesteAssistenzaReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ASSISTENZA_SET_SELECTED_TAB:
            return setSelectedTab(state, action);
        case actionTypes.SET_LOADING_ASSISTENZA:
            return setLoadingAssistenza(state, action);
        case actionTypes.FETCH_ASSISTENZA_DATA_SUCCESS:
            return fetchAssistenzaDataSuccess(state, action);
        case actionTypes.SET_SORTING_RICHIESTA:
            return setSortingRichiesta(state, action);
        case actionTypes.SET_ASSISTENZA_SUGGESTION_LOADING:
            return setRichiesteAssistenzaSuggestionLoading(state, action);
        case actionTypes.SET_ASSISTENZA_FILTER_SUGGESTION_DATA:
            return setRichiesteAssistenzaFilterSuggestionData(state, action);
        default:
            return state;
    }
};

export default richiesteAssistenzaReducer;
